import { Button, Stack, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useAuthContext } from '../../../context/AuthContext';
import constants from '../../../utils/Constants';
import { Add } from '@mui/icons-material';
import route from '../../../utils/Routes';
import { useNavigate } from 'react-router-dom';
import StyledTableContainer from '../../../components/StyledTableContainer';
import { formatDateWithJs, formatUserType, NumberFormatter, NumFormatter } from '../../../utils/format';

const columns = [
    {
        id: 'id',
        label: "S.No",
        align: 'left',
        minWidth: 50,
    },
    {
        id: 'doIdStrg',
        label: "DO ID",
        align: 'left',
        minWidth: 100
    },
    {
        id: 'actDoNum',
        label: "DO Number",
        align: 'left',
        minWidth: 100
    },
    {
        id: 'prodCount',
        label: "Products Count",
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'invNo',
        label: "Invoice No",
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'invDate',
        label: "Invoice Date",
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'pymtStatus',
        label: "Payment Status",
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'deliveredAt',
        label: "Delivered At",
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'createdByUser',
        label: "Created By",
        align: 'left',
        minWidth: 100,
    },
];


function DoList({ height, dos, poIdStrg, poStatus }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const { ctxtUser } = useAuthContext();

    function handleAddDoClick() {
        navigate(route.aDoCreate, { state: { poIdStrg } });
    };

    const handleRowClick = (doIdStrg) => {
        if (ctxtUser?.isComUser)
            navigate(`${route.cDoInfo}/?doId=${doIdStrg}`);
        else
            navigate(`${route.aDoInfo}/?doId=${doIdStrg}`);
    };

    return (
        <Stack width={"100%"} >
            <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-between"} mb={2} px={1.3}>
                <Typography fontSize={15} fontWeight="medium">
                    Delivery Order List
                </Typography>
                {((ctxtUser?.userType === constants.store || ctxtUser?.userType === constants.admin) && poStatus !== "order_completed") && <Button variant='outlined' onClick={handleAddDoClick} startIcon={<Add />} sx={{
                    fontSize: 13, color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                }}>
                    Create DO</Button>}
            </Stack>
            <StyledTableContainer maxHeight={height} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {columns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(dos || []).map((i, index) => {
                        return (
                            <React.Fragment key={i?.id}>
                                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.doIdStrg)}
                                    sx={{ height: 33, cursor: 'pointer' }} >
                                    {columns.map((column) => {
                                        const value = i[column.id];
                                        switch (column.id) {
                                            case "id":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {index + 1}
                                                </TableCell>
                                            case "prodCount":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {NumFormatter(value)}
                                                </TableCell>
                                            case "pymtStatus":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatUserType(value)}
                                                </TableCell>
                                            case "invDate":
                                            case "deliveredAt":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "NA" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </StyledTableContainer>
        </Stack>
    )
}

export default DoList